import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getCommonKeywordsWithTags } from '../../../../services/monitor/keywords/KeywordsService';
import { KeywordResponse } from '../../../../models/monitor/KeywordResponse';
import { GET_COMMON_KEYWORDS } from '../../../query/keyword/keys';

export const useGetCommonKeywordsWithTags = (projectId: number | null) => {
  const queryClient = useQueryClient();
  const queryEnabled = !!projectId;

  const {
    data: commonKeywords,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery<KeywordResponse[]>({
    queryKey: [GET_COMMON_KEYWORDS, projectId],
    queryFn: () => getCommonKeywordsWithTags(projectId!),
    staleTime: 0,
    gcTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    enabled: queryEnabled,
    retry: 3,
    retryDelay: 1000,
  });

  const invalidate = () =>
    queryClient.invalidateQueries({
      queryKey: [GET_COMMON_KEYWORDS, projectId],
      refetchType: 'active',
    });

  return {
    commonKeywords: queryEnabled ? commonKeywords ?? [] : [],
    isLoading: queryEnabled ? isLoading : false,
    isError: queryEnabled ? isError : false,
    error: queryEnabled ? error : null,
    refetch,
    invalidate,
  };
};
